<template>
    <v-server-table
        url="/api/admin/trajectory-projects/table"
        :columns="columns"
        :options="options"
        class="trigger projects-server-table"
        ref="table"
    >
        <template slot="name" slot-scope="props">
            <router-link :to="{ name: 'admin.trajectory_projects.view', params: { id: props.row.id }}" :style="nameColor(props.row.active)">
                {{ props.row.name }}
                <small v-if="!props.row.active">
                    {{ uLang('app.inactive') }}
                </small>
            </router-link>
        </template>
    </v-server-table>
</template>

<script>
    import Actions from './actions'
    import { TableMixin } from '~/mixins'

    export default {
        name: 'index',
        mixins: [TableMixin],
        props: {
            showInactiveProjects: {
                type: Boolean,
                default: false
            },
            rowsPerPage: {
                type: String,
                default: "15"
            }
        },
        mounted: function () {
            this.$refs.table.query.showInactive = false
        },
        created: function () {
            //set filter placeholder column name lowercase
            setTimeout(function () {
                [].forEach.call(
                    document.querySelectorAll('.VueTables__filters-row th input'),
                    function (el) {
                        let placeholder = el.placeholder.toLowerCase();
                        el.placeholder = placeholder.charAt(0).toUpperCase() + placeholder.slice(1);
                    }
                );
            }, 15);
        },
        data() {
            return {
                columns: ['name', 'actions'],
                filterable: ['name'],
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        name: this.uLang('app.name'),
                        actions: this.uLang('app.actions'),
                    },
                }
            }
        },
        methods: {
            nameColor(isActive) {
                return !isActive ? 'color: #808080;' : ''
            }
        },
        watch: {
            showInactiveProjects(shouldShow) {
                this.$refs.table.query.showInactive = shouldShow
                this.$refs.table.refresh();
            },
            rowsPerPage(newValue) {
                this.$refs.table.setLimit(Number.parseInt(newValue, 10));
                this.$refs.table.refresh();
            }
        },
    }
</script>

<style lang="scss">
    .projects-server-table thead tr th:first-child {
        width: 90%;
    }
</style>
